var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKanban(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17233_100928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 3.33398H8.33325",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 3.33398H16.6667",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 6.66602H4.99992C4.07944 6.66602 3.33325 7.41221 3.33325 8.33268V14.9993C3.33325 15.9198 4.07944 16.666 4.99992 16.666H6.66659C7.58706 16.666 8.33325 15.9198 8.33325 14.9993V8.33268C8.33325 7.41221 7.58706 6.66602 6.66659 6.66602Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 6.66602H13.3334C12.4129 6.66602 11.6667 7.41221 11.6667 8.33268V9.99935C11.6667 10.9198 12.4129 11.666 13.3334 11.666H15.0001C15.9206 11.666 16.6667 10.9198 16.6667 9.99935V8.33268C16.6667 7.41221 15.9206 6.66602 15.0001 6.66602Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17233_100928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanban);
export default __webpack_public_path__ + "static/media/kanban.48be0aa3bc9c2556a2d5089438eb948c.svg";
export { ForwardRef as ReactComponent };